import {
  GET_DL_BILL_REQUEST,
  GET_DL_BILL_SUCCESS,
  GET_DL_BILL_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getDlBill = (token, values) => (dispatch) => {
  dispatch({ type: GET_DL_BILL_REQUEST });
  const newData = {
    date_from: moment(values.from_date).format("MM-DD-YYYY"),
    date_to: moment(values.to_date).format("MM-DD-YYYY"),
    gender_id: (values.gender === "All" || values.gender === undefined) ? null : values.gender,
    gender_category_id: (values.gender_category_id === "All" || values.gender_category_id === undefined) ? null : values.gender_category_id,
    ship_via_id: (values.shipVia === "All" || values.shipVia === undefined) ? null : values.shipVia,
    vendor_id: (values.vendor === "All" || values.vendor === undefined) ? null : values.vendor,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DlBillData`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData
  })
    .then((response) => {
      return dispatch({
        type: GET_DL_BILL_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DL_BILL_ERROR,
        payload: [],
      });
    });
};
